jQuery(document).ready(function($){

  function discount_cal(originalPrice, discountedPrice) {
        // if (originalPrice <= 0) {
        //     throw new Error("Original price must be greater than zero.");
        // }
        if (discountedPrice < 0) {
            throw new Error("Discounted price cannot be negative.");
        }
        const discountAmount = originalPrice - discountedPrice;
        const discountPercentage = (discountAmount / originalPrice) * 100;
        return discountPercentage.toFixed(); // Returns the discount percentage rounded to two decimal places
    }
  jQuery(document).scroll(function() {
    var cutoff = jQuery(window).scrollTop();
    var cutoffRange = jQuery('#delivery_options').offset().top;
    if (cutoff > cutoffRange+180) {
      jQuery('#mobile_layout').addClass('fixedbar');
    } else {
      jQuery('#mobile_layout').removeClass('fixedbar');
    }

  });
  $('#packtype a').on('click', function(e){
    e.preventDefault();
      var t = $(this);
      var txt = t.html();
    var v = t.data('packtype');
    t.addClass('active').siblings().removeClass('active');
    $('#pack_type').html(txt);
    // $('#lw_empty_bottles').html('');
    var packqty = jQuery('#packtype a.active').data('packtype');
      
      var val = 0;
       jQuery('.lwactive input[type="number"]').each(function(){
         val += parseInt(jQuery(this).val());
         var totalqty = parseInt(jQuery(this).val());
         var imgurl = jQuery(this).parent().parent().parent().find('.thumb img.addon_img').attr('src');
         if( totalqty > 0 ){
          jQuery('#lw_empty_bottles').append('<div class="lw_btle"><img loading="lazy" src="'+imgurl+'" width="28" height="68" /><br/>'+totalqty+'x</div>'); }
      });
      var greybtle = packqty-val;
      // for (let i=0; i<greybtle; i++){
        $('#lw_empty_bottles').append('<div class="lw_btle"><img loading="lazy" src="https://cdn.shopify.com/s/files/1/0248/9496/3802/files/empty_bottle.png?v=1647870483" width="28" height="68" /></div>');
      // }
      if( packqty == val ){
        jQuery('#box_addtocart, #boxaddtocart').prop('disabled', false);
        jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6:not(.lwactive)  button').prop('disabled', true);
        jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6.lwactive  button.plusbab, #quick_box button.plusbab').prop('disabled', true);
      }else if( val < packqty  ){
        jQuery('#box_addtocart, #boxaddtocart').prop('disabled', true);
        jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6:not(.lwactive) button').prop('disabled', false);
        jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6.lwactive  button.plusbab, #quick_box button.plusbab').prop('disabled', false);
      }
      jQuery('#bundle_qtys').val(val); 
      jQuery('#total_numbeblts').text(val); 
    
    if( v == 10 ){
      jQuery('input[name="lw_bundle_packs"][value="10"]').prop('checked', true).trigger('change');
      jQuery('#lwbox').text('10');
    }
    if( v == 12 ){
      jQuery('input[name="lw_bundle_packs"][value="12"]').prop('checked', true).trigger('change');
      jQuery('#lwbox').text('12');
    }
    if( v == 14 ){
      jQuery('input[name="lw_bundle_packs"][value="14"]').prop('checked', true).trigger('change');
      jQuery('#lwbox').text('14');
    }
    if( v == 18 ){
      jQuery('input[name="lw_bundle_packs"][value="18"]').prop('checked', true).trigger('change');
      jQuery('#lwbox').text('18');
    }
    
  });
  $('#mobile_delivery a').on('click', function(e){
    e.preventDefault();
      var t = $(this);
      var txt = t.html();
    var v = t.data('deliverytime');
    $('#mdlivry').html(txt);
    
    if( v == 'onetime' ){
      jQuery('#box-plan').val('');
    }
    if( v == 'every_weeks' ){
      var plan_id = jQuery('.plan-id-1-week').data("id");
      jQuery('#box-plan').val(plan_id);
    }
    if( v == 'every_twoweeks' ){
      var plan_id = jQuery('.plan-id-2-weeks').data("id");
      jQuery('#box-plan').val(plan_id);
    }
    if( v == 'every_month' ){
      var plan_id = jQuery('.plan-id-4-weeks').data("id");
      jQuery('#box-plan').val(plan_id);
    }
    if( v == 'every_sixweek' ){
      var plan_id = jQuery('.plan-id-6-weeks').data("id");
      jQuery('#box-plan').val(plan_id);
    }
  });
  $('input[name="lw_subscription_opt"]').on('change', function(){
      var t = $(this);
      var v = t.val();
    if( v == 'onetime' ){
       jQuery('#box-plan').val('');
    }
     var plan_id;
    if( v == 'every_weeks'){
       plan_id = jQuery('.plan-id-1-week').data("id");
      jQuery('#box-plan').val(plan_id);
    }
    if( v == 'every_twoweeks'){
       plan_id = jQuery('.plan-id-2-weeks').data("id");
      jQuery('#box-plan').val(plan_id);
    }
    if( v == 'every_month'){
     plan_id = jQuery('.plan-id-4-weeks').data("id");
      jQuery('#box-plan').val(plan_id);
    }
    if( v == 'every_sixweek'){
       plan_id = jQuery('.plan-id-6-weeks').data("id");
      jQuery('#box-plan').val(plan_id);
    }
    
  });
  for (let i=0; i<10; i++){
    $('#lw_empty_bottles').append('<div class="lw_btle"><img src="https://cdn.shopify.com/s/files/1/0248/9496/3802/files/empty_bottle.png?v=1647870483" width="28" height="68" /></div>');
  }
  $('input[name="lw_bundle_packs"]').on('change', function(){
      var t = $(this);
      var v = t.val();
    $('#change_box_id').val(v);
    var dis = t.data('discount');
    var packqty = jQuery('input[name="lw_bundle_packs"]:checked').val();
      var val = 0;  
     
       jQuery('.lwactive input[type="number"]').each(function(){
         val += parseInt(jQuery(this).val());
         var totalqty = parseInt(jQuery(this).val());
         var namep = jQuery(this).data('name');
         var imgurl = jQuery(this).parent().parent().parent().find('.thumb img.addon_img').attr('src');
      });
 
      var greybtle = packqty-val;
      if( packqty == val ){
        jQuery('#box_addtocart').prop('disabled', false);
        jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6:not(.lwactive)  button').prop('disabled', true);
        jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6.lwactive  button.plusbab').prop('disabled', true);
      }else if( val < packqty  ){
          jQuery('#box_addtocart').prop('disabled', true);
        jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6:not(.lwactive) button').prop('disabled', false);
        jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6.lwactive  button.plusbab').prop('disabled', false);
      }
      if( val > packqty  ){
          jQuery('#box_addtocart').prop('disabled', true);
      }
      jQuery('#bundle_qtys').val(val); 
      jQuery('#total_numbeblts').text(val); 
    
    if( v == '10' ){
      $('#lw_empty_bottles').addClass('packone');
      $('#lw_empty_bottles').removeClass('packthree');
      $('#lw_empty_bottles').removeClass('packtwo');
      jQuery('#lw_option_1').prop('checked', true).trigger('change');
      jQuery('#lwbox').text('10');
      $('#pack_type').html('><strong>10 Packs</strong><br/>$7.30 per bottle');
    }
    if( v == '12' ){
      $('#lw_empty_bottles').addClass('packtwo');
      $('#lw_empty_bottles').removeClass('packthree');
      $('#lw_empty_bottles').removeClass('packone');
      jQuery('#lw_option_2').prop('checked', true).trigger('change');
      jQuery('#lwbox').text('12');
      $('#pack_type').html('<strong>12 Packs</strong><br/>$7.00 per bottle (12% Off)');
    }
    if( v == '14' ){
      $('#lw_empty_bottles').addClass('packfour');
      $('#lw_empty_bottles').removeClass('packthree');
      $('#lw_empty_bottles').removeClass('packone');
      jQuery('#lw_option_3').prop('checked', true).trigger('change');
      jQuery('#lwbox').text('14');
      $('#pack_type').html('<strong>14 Packs</strong><br/>$6.60 per bottle (12% Off)');
    }
    if( v == '18' ){
      $('#lw_empty_bottles').addClass('packthree');
      $('#lw_empty_bottles').removeClass('packtwo');
      $('#lw_empty_bottles').removeClass('packone');
      jQuery('#lw_option_4').prop('checked', true).trigger('change');
      jQuery('#lwbox').text('18');
      $('#pack_type').html('<strong>18 Packs</strong><br/>$6.00 per bottle (19% Off)');
    }
     
  });
  $(document.body).on('change', 'input[name="lw_bundle_packs"]', function(){
      var t = $(this);
      var v = t.val();
      var sltd_qtys = jQuery('#sltd_qtys').val();
      var bundle_qtys = jQuery('#bundle_qtys').val();
       
     jQuery('#sltd_qtys').val(v);
     var val = 0;
      jQuery('.lwactive input[type="number"]').each(function(){
        val += parseInt(jQuery(this).val());
        var totalqty = parseInt(jQuery(this).val());
      });
      
    if( v < sltd_qtys && bundle_qtys > 0  ){
      $('#sltdboxqty').val(sltd_qtys);
      $('#lw_reset_my_box').modal('show');
      $('input[name="lw_bundle_packs"][value="'+sltd_qtys+'"]').prop('checked', true);
      $('#sltd_qtys').val(sltd_qtys);
      // $('#lw_empty_bottles').html('');
      
      
      var greybtle = sltd_qtys-val;
      // for (let i=0; i<greybtle; i++){
      //   $('#lw_empty_bottles').append('<div class="lw_btle"><img src="https://cdn.shopify.com/s/files/1/0248/9496/3802/files/empty_bottle.png?v=1647870483" width="28" height="68" /></div>');
      // }
      if( sltd_qtys == val ){
         
        jQuery('#box_addtocart').prop('disabled', false);
        jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6:not(.lwactive)  button').prop('disabled', true);
        jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6.lwactive  button.plusbab').prop('disabled', true);
      }else if( val < sltd_qtys  ){
        jQuery('#box_addtocart').prop('disabled', true);
        jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6:not(.lwactive) button').prop('disabled', false);
        jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6.lwactive  button.plusbab').prop('disabled', false);
      }
      if( val > sltd_qtys  ){
        jQuery('#box_addtocart').prop('disabled', true);
      }
      jQuery('#bundle_qtys').val(val); 
      jQuery('#total_numbeblts').text(val); 
      if( sltd_qtys == '10' ){
      $('#lw_empty_bottles').addClass('packone');
      $('#lw_empty_bottles').removeClass('packthree');
      $('#lw_empty_bottles').removeClass('packtwo');
        jQuery('#lw_option_1').prop('checked', true).trigger('change');
        jQuery('#lwbox').text('10');
      $('#pack_type').html('<strong>10 Packs</strong><br/>$9.00 per bottle (0% Off)');
      }
      if( sltd_qtys == '12' ){
      $('#lw_empty_bottles').addClass('packtwo');
      $('#lw_empty_bottles').removeClass('packthree');
      $('#lw_empty_bottles').removeClass('packone');
        jQuery('#lw_option_2').prop('checked', true).trigger('change');
        jQuery('#lwbox').text('12');
      $('#pack_type').html('<strong>12 Packs</strong><br/>$8.00 per bottle (12% Off)');
      }
      if( sltd_qtys == '18' ){
      $('#lw_empty_bottles').addClass('packthree');
      $('#lw_empty_bottles').removeClass('packtwo');
      $('#lw_empty_bottles').removeClass('packone');
        jQuery('#lw_option_3').prop('checked', true).trigger('change');
        jQuery('#lwbox').text('18');
      $('#pack_type').html('<strong>18 Packs</strong><br/>$7.25 per bottle (19% Off)');
      }
    }else{
      var ddp = t.data('price');
        var oprice = val * 8.00;
        var dprice = val * ddp;
        
        var percentage = discount_cal( oprice, dprice );

        $('.total_price .dis_tag').text(percentage+'% OFF');

        var ttprice = $('[name="lw_bundle_packs"]:checked').data('price');
        var tprice = ttprice * val;
        $('[data-bab_price]').html( '$'+ tprice.toFixed(2) ); 
    }
  }); 
  $('#clear_my_box').on('click', function(){
    var sltd_qtys = jQuery('#sltd_qtys').val();
    var bundle_qtys = jQuery('#bundle_qtys').val();
    var change_box_id = jQuery('#change_box_id').val();
    $('#box_addtocart,#boxaddtocart').prop('disabled', true);
    jQuery('.row.alljuices button').prop('disabled', false); 
    jQuery('.row.alljuices input[type="number"]').val(0);
      jQuery('#sltdboxqty').val('');
      jQuery('#sltd_qtys').val(change_box_id);
    jQuery('input[name="lw_bundle_packs"][value="'+change_box_id+'"]').prop('checked', true);
    $('#lw_reset_my_box').modal('hide');
    $('#lw_empty_bottles').html('');
    $('.total_price .dis_tag').css('opacity', 0);
     $('[data-bab_price]').html( '$0.00');
    for (let i=0; i<change_box_id; i++){

      $('#lw_empty_bottles').append('<div class="lw_btle"><img src="https://cdn.shopify.com/s/files/1/0248/9496/3802/files/empty_bottle.png?v=1647870483" width="28" height="68" /></div>');
    }
    var val = 0;
    if( val > sltd_qtys  ){
      jQuery('#box_addtocart').prop('disabled', true);
    }
    jQuery('#bundle_qtys').val(0); 
    jQuery('#total_numbeblts').text(0); 

    if( change_box_id == '10' ){
      $('#lw_empty_bottles').addClass('packone');
      $('#lw_empty_bottles').removeClass('packthree');
      $('#lw_empty_bottles').removeClass('packtwo');
      jQuery('#lw_option_1').prop('checked', true).trigger('change');
      jQuery('#lwbox').text('10');
      $('#pack_type').html('<strong>10 Packs</strong><br/>$9.00 per bottle (0% Off)');
    }
    if( change_box_id == '12' ){
      $('#lw_empty_bottles').addClass('packtwo');
      $('#lw_empty_bottles').removeClass('packthree');
      $('#lw_empty_bottles').removeClass('packone');
      jQuery('#lw_option_2').prop('checked', true).trigger('change');
      jQuery('#lwbox').text('12');
      $('#pack_type').html('<strong>12 Packs</strong><br/>$8.00 per bottle (12% Off)');
    }
    if( change_box_id == '18' ){
      $('#lw_empty_bottles').addClass('packthree');
      $('#lw_empty_bottles').removeClass('packtwo');
      $('#lw_empty_bottles').removeClass('packone');
      jQuery('#lw_option_3').prop('checked', true).trigger('change');
      jQuery('#lwbox').text('18');
      $('#pack_type').html('<strong>18 Packs</strong><br/>$7.25 per bottle ( 19% Off)');
    }

  });

   setTimeout(function(){
      jQuery('.bsub-widget__group.onceprogram input').prop('checked', true).trigger('change');
    }, 900 );
    jQuery(document.body).on("click", ".lwaddons button.minusbab", function (e) {
      var t = jQuery(this);
      var tr = t.next('input.qty');
      var val = tr.val();
      var minus = Number(val)-1;
      var ttval = jQuery('#bundle_qtys').val();
      if( minus > 0 || minus == 0 ){
        tr.val(minus); 
      var totalss = Number(ttval)-1;
      }
      console.log('totalss ' +totalss);
      jQuery('#total_numbeblts').text(totalss); 
      jQuery('#bundle_qtys').val(totalss); 
      
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) { 
      	var packqty = jQuery('#packtype a.active').data('packtype');
      }else{
      	var packqty = jQuery('input[name="lw_bundle_packs"]:checked').val();
      } 
         
    
        if( packqty == totalss ){
        	jQuery('#box_addtocart, #boxaddtocart').prop('disabled', false);
          jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6:not(.lwactive)  button').prop('disabled', true);
          jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6.lwactive  button.plusbab, #add-to_box button.plusbab').prop('disabled', true);
        }else if( totalss < packqty  ){
        	jQuery('#box_addtocart, #boxaddtocart').prop('disabled', true);
          jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6:not(.lwactive) button').prop('disabled', false);
          jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6.lwactive button.plusbab, #add-to_box button.plusbab').prop('disabled', false);
        }
    }); 
    jQuery(document.body).on("click", ".lwaddons button.plusbab", function (e) {
      var t = jQuery(this);
      var tr = t.prev('input.qty');
      var price = tr.data('prodprice');
      var id = tr.attr('id');
      var val = tr.val();
      var ttval = jQuery('#bundle_qtys').val();
      var plus = Number(val)+1;
      var n = plus*price;
      tr.val(plus);
      jQuery('#total_numbeblts').text(Number(ttval)+1); 
      jQuery('#bundle_qtys').val(Number(ttval)+1); 
      jQuery('#bundle_qty').val(Number(ttval)+1); 
       if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) { 
      	var packqty = jQuery('#packtype a.active').data('packtype');
      }else{
      	var packqty = jQuery('input[name="lw_bundle_packs"]:checked').val();
      }
      var sltd_qtys = jQuery('#sltd_qtys').val();

      var ttvals = jQuery('#bundle_qtys').val();
      var custom = jQuery('input[name="lw_bundle_packs"]:checked').val();
        
      
     // jQuery('#bundle_qtys').val(val); 
    });
    
    
    jQuery(document.body).on('click', '#box_addtocart, #boxaddtocart', function(){
    	jQuery('button.add-to-cart.addtocart').trigger('click');
    });
    jQuery(document.body).on('click', '.lw_addons button', function(){
    	var t = jQuery(this);
      t.parent().find('input[type="number"]').trigger('change');
      var i = 0;
      jQuery('.lwactive .box_checkbox').each(function(e){
         i++
        jQuery(this).attr("name", "properties["+i+"]");
        
      });
      
      
    });
    jQuery(document.body).on('change', '.lw_addons input[type="number"]', function(){
      var t = jQuery(this);
      var v = t.val();
      t.parent().parent().parent().addClass('lwactive');
      t.parent().parent().parent().find('input[type="checkbox"]').prop('checked', true);
      jQuery('#lw_empty_bottles').html('');
      setTimeout(function(){
        var val = 0;
         if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) { 
      	var packqty = jQuery('#packtype a.active').data('packtype');
      }else{
      	var packqty = jQuery('input[name="lw_bundle_packs"]:checked').val();
      }
        jQuery('.lwactive input[type="number"]').each(function(){
           val += parseInt(jQuery(this).val());
           var totalqty = parseInt(jQuery(this).val());
           var imgurl = jQuery(this).parent().parent().parent().find('.thumb img.addon_img').attr('src');
            if( totalqty > 0 ){
           	jQuery('#lw_empty_bottles').append('<div class="lw_btle"><img loading="lazy" src="'+imgurl+'"><br/>'+totalqty+'x</div>'); }
        });
        var ddp = $('[name="lw_bundle_packs"]:checked').data('price');
        var oprice = val * 8.00;
        var dprice = val * ddp;

        var percentage = discount_cal( oprice, dprice );

        $('.total_price .dis_tag').text(percentage+'% OFF');
        var ttvals = jQuery('#bundle_qtys').val();
        if( val > 0 ){
          $('.total_price .dis_tag').css('opacity', 1);
        }else{
          $('.total_price .dis_tag').css('opacity', 0);
        }
        var greybtle = packqty-val;
        // for (let i=0; i<greybtle; i++){
        //   $('#lw_empty_bottles').append('<div class="lw_btle"><img loading="lazy" src="https://cdn.shopify.com/s/files/1/0248/9496/3802/files/empty_bottle.png?v=1647870483" /></div>');
        // }
        var custom = jQuery('input[name="lw_bundle_packs"]:checked').val();
       if( custom == 18){
         
         if( ttvals == 40 ){
          jQuery('#box_addtocart, #boxaddtocart').prop('disabled', false);
          jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6:not(.lwactive)  button').prop('disabled', true);
          jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6.lwactive button.plusbab, #add-to_box button.plusbab').prop('disabled', true);
        }else if( ttvals > 14 || ttvals == 40 ){
          jQuery('#box_addtocart, #boxaddtocart').prop('disabled', false);
          jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6:not(.lwactive)  button').prop('disabled', false);
          jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6.lwactive button.plusbab, #add-to_box button.plusbab').prop('disabled', false);
        }

      }else{
        if( packqty == ttvals ){  
           jQuery('body').append('<div id="box_cmpltd_msg" class="box_cmpltd_msg"><div class="alert alert-success d-table">Your box completed!</div></div>');
          setTimeout(function(){
          	jQuery('#box_cmpltd_msg').fadeOut().remove();
          }, 2500 );
        	jQuery('#box_addtocart, #boxaddtocart').prop('disabled', false);
          jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6:not(.lwactive)  button').prop('disabled', true);
          jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6.lwactive button.plusbab, #add-to_box button.plusbab').prop('disabled', true);
        }else if( ttvals < packqty  ){
        	jQuery('#box_addtocart, #boxaddtocart').prop('disabled', true);
          jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6:not(.lwactive) button').prop('disabled', false);
          jQuery('.row.alljuices .col-lg-3.col-md-4.col-sm-6.lwactive button.plusbab, #add-to_box button.plusbab').prop('disabled', false);
        }
      }
        /*if( packqty == val ){
        	jQuery('#box_addtocart, #boxaddtocart').prop('disabled', false);
          jQuery('.row.alljuices .col-lg-4.col-md-4.col-sm-6:not(.lwactive)  button').prop('disabled', true);
          jQuery('.row.alljuices .col-lg-4.col-md-4.col-sm-6.lwactive  button.plusbab, #quick_box button.plusbab').prop('disabled', true);
        }else if( val < packqty  ){
        	jQuery('#box_addtocart, #boxaddtocart').prop('disabled', true);
          jQuery('.row.alljuices .col-lg-4.col-md-4.col-sm-6:not(.lwactive) button').prop('disabled', false);
          jQuery('.row.alljuices .col-lg-4.col-md-4.col-sm-6.lwactive  button.plusbab, #quick_box button.plusbab').prop('disabled', false);
        }*/


        jQuery('#bundle_qtys').val(val);
        jQuery('#total_numbeblts').text(val); 
        var ttprice = $('[name="lw_bundle_packs"]:checked').data('price');
        var tprice = ttprice * val;
        $('[data-bab_price]').html( '$'+ tprice.toFixed(2) );
      }, 30);
      setTimeout(function(){
        
        t.parent().parent().parent().find('input[type="checkbox"]').val(pname+' x '+pqty);
        var pname = t.parent().parent().parent().find('h3').data('name');
        var pqty = t.parent().parent().parent().find('input[type="number"]').val();
        if( pqty == 0 ){
            t.parent().parent().parent().find('input[type="checkbox"]').prop('checked', false);
            t.parent().parent().parent().find('input[type="checkbox"]').val(pname);
            t.parent().parent().parent().removeClass('lwactive');
        }else{
        	t.parent().parent().parent().find('input[type="checkbox"]').val(pname+' x '+pqty);
        }
        
      }, 500);
    });
    
    jQuery(document.body).on('change', '.swatch input', function(){
    	var t = jQuery(this);
      	var v = t.val(); 
      	var p = t.data('vprice');
      jQuery('#product-selectors').val(v);
      
    });
});